<template>
  <div class="outer-box">
    <h3>Support endpoints</h3>
    <div v-if="bigResponse" class="inner-box" style="text-align: left; width: 620px">
      <h5>Endpoint response</h5>
      <div v-if="Array.isArray(bigResponse)">
        <p v-for="(response, index) in bigResponse" :key="index">{{ response }}</p>
      </div>
      <div v-else>
        <p>{{ bigResponse }}</p>
      </div>
      <button class="btn btn-success" @click="bigResponse = null">Close</button>
    </div>
    <div v-else class="inner-box" style="text-align: left; width: 620px">
      <Endpoint
        v-for="(endpoint, index) in supportEndpoints"
        :key="index"
        :endpointObject="endpoint"
        :loading="loading"
      />
    </div>

    <multiple-users-modal
      v-if="showModal"
      :multiple-users-data="multipleUsersData"
      @submit="modalSubmit"
      @close="closeModal"
    />
    <user-data-modal
      v-if="userData.showModal"
      @closeUserModal="closeUserDataModal"
      :user="userData.user"
      :company="userData.company"
    ></user-data-modal>
  </div>
</template>

<script>
import router from "@/router";
import Endpoint from "./Endpoint.vue";
import MultipleUsersModal from "./MultipleUsersModal.vue";
import UserDataModal from "./UserDataModal.vue";
import reusable from "@/mixins/reusable";
import {
  SpmAppengineService,
  IntegrationsService,
  InternalToolsService,
  OAuthService,
  UserService,
  CalendarService,
  LocationsService,
} from "@/services";

export default {
  components: { Endpoint, MultipleUsersModal, UserDataModal },
  mixins: [reusable],
  data() {
    return {
      loading: {},
      bigResponse: null,
      showModal: false,
      userData: {
        showModal: false,
        user: null,
        company: null,
      },
      multipleUsersData: {
        endpoint: null,
        data: null,
      },
    };
  },
  computed: {
    supportEndpoints() {
      return [
        {
          name: "Reset password",
          url: "reset_password/",
          params: [
            {
              value: null,
              placeholder: "User e-mail",
            },
          ],
          action: this.checkForMultipleUsers,
          multipleUsersIsPossible: true,
          bigResponse: false,
        },
        // {
        //   name: "Reset email and password",
        //   info: "Enter the old email address of the account for which you want to change the email address and password<br/><a href='https://www.lastpass.com/password-generator' target='_blank'>LassPass Pwd generator</a> Copy the new password from this link and paste it here.",
        //   url: "reset_email_password/",
        //   params: [
        //     {
        //       value: null,
        //       placeholder: "Old E-mail ID",
        //     },
        //     {
        //       value: null,
        //       placeholder: "New E-mail ID",
        //     },
        //     {
        //       value: null,
        //       placeholder: "New Password",
        //     },
        //     {
        //       value: null,
        //       type: "note",
        //       placeholder:
        //         "at least 1 uppercase, at least 1 lowercase, at least 1 special character, at least 8 character long ",
        //     },
        //   ],
        //   action: this.resetEmailAndPassword,
        // },
        {
          name: "Find User",
          url: "user/get-user/",
          params: [
            {
              value: null,
              placeholder: "User ID or email",
            },
          ],
          action: this.getUserDetail,
          multipleUsersIsPossible: true,
          bigResponse: false,
        },
        // {
        //   name: "Make Agency Admin",
        //   info:
        //     "Changes the User with the provided e-mail to an Agency Admin",
        //   url: "user/make_agency_admin/",
        //   params: [
        //     {
        //       value: null,
        //       placeholder: "User e-mail"
        //     }
        //   ],
        //   action: this.checkForMultipleUsers,
        //   multipleUsersIsPossible: true,
        //   bigResponse: false
        // },
        {
          name: "Find Agency admin",
          info: "Will return admins when the provided e-mail or relationship_number matches the Company e-mail or relationship_number in Agency Settings",
          url: "agency/get_admins/from_email/",
          params: [
            {
              value: null,
              placeholder: "Agency Rel_No or e-mail",
            },
          ],
          action: this.checkForMultipleUsers,
          multipleUsersIsPossible: true,
          bigResponse: true,
        },
        {
          name: "Find Location admin",
          info: "Will return admins when the provided e-mail matches the Company e-mail in Location Settings",
          url: "location/get_admins/from_email/",
          params: [
            {
              value: null,
              placeholder: "Location e-mail",
            },
          ],
          action: this.bigResponseSingleParam,
        },
        {
          name: "Reset Location Email",
          info: "This will reset the location email present on the business profile page to the new value entered here.",
          url: "locations/",
          params: [
            {
              value: null,
              placeholder: "Location ID",
            },
            {
              value: null,
              placeholder: "Location e-mail",
            },
          ],
          action: this.resetLocationEmail,
        },
        {
          name: "Enable Depreciated Features (E-mail)",
          info: "Will eanble the campaings and triggers from depreciated features for all the location of the provided Agency",
          url: "depreciated_features/enable?email=",
          params: [
            {
              value: null,
              placeholder: "Agency e-mail",
            },
          ],
          action: this.checkForMultipleUsers,
          multipleUsersIsPossible: true,
          bigResponse: true,
        },
        // {
        //   name: "Delete All Contacts",
        //   info:
        //     "DANGER! Deletes ALL contacts from the given Location ID",
        //   url: "contact/delete_all/",
        //   params: [
        //     {
        //       value: null,
        //       placeholder: "Location ID"
        //     }
        //   ],
        //   action: this.singleParamGetAction
        // },
        {
          name: "Queue All Campaign",
          info: "Queues ALL of the running Campaign Steps from the given Campaign ID for all Contacts inside it",
          url: "campaigns/queue_all/",
          params: [
            {
              value: null,
              placeholder: "Campaign ID",
            },
          ],
          action: this.singleParamGetAction,
        },
        {
          name: "De-duplicate Tags",
          info: "Removes every tag duplicate and leaves only 1 for each.",
          url: "tag/deduplicate/",
          params: [
            {
              value: null,
              placeholder: "Location ID",
            },
          ],
          action: this.singleParamGetAction,
        },
        {
          name: "Twilio Create Application",
          info: "Adds a TwiML application to the Twilio account.",
          url: "twilio/create_application/",
          params: [
            {
              value: null,
              placeholder: "Location ID",
            },
          ],
          action: this.singleParamGetAction,
        },
        // {
        //   name: "Add Stripe ID",
        //   info: "Sets the Stripe ID of the provided email's Company",
        //   url: "stripe/update_id",
        //   params: [
        //     {
        //       value: null,
        //       placeholder: "Company e-mail",
        //     },
        //     {
        //       value: null,
        //       placeholder: "Stripe ID",
        //     },
        //   ],
        //   action: this.addStripeID,
        // },
        {
          name: "Unlink Snapshot from Location",
          info: "To get the snapshot ID you can click on Add To Account and the ID will be on the URL",
          url: "location/remove_snapshot/",
          params: [
            {
              value: null,
              placeholder: "Location ID",
            },
            {
              value: null,
              placeholder: "Snapshot ID",
            },
          ],
          action: this.removeSnapshot,
        },
        {
          name: "Unlink all snapshots from Location",
          info: "Will remove all snapshots from the linked snapshots of the provided Location.",
          url: "location/remove_all_snapshots/",
          params: [
            {
              value: null,
              placeholder: "Location ID",
            },
          ],
          action: this.singleParamGetAction,
        },
        // {
        //   name: 'Clear all Mailgun Errors of the provided API key',
        //   info: 'Once the error message issue is resolved, use this endpoint to clear the error message.',
        //   url: 'mailgun/clear_errors/',
        //   params: [
        //     {
        //       value: null,
        //       placeholder: "Mailgun API Key"
        //     }
        //   ],
        //   action: this.singleParamGetAction
        // },
        // {
        //   name: "Merge Contacts",
        //   info: "Fills empty fields from the Main contact with fields from the Second contact, then deletes the Second contact. Can perform a Merge (false) or Delete (true) of Opportunities and Conversations. Usually, Delete (true) is best.",
        //   url: "contact/merge_contacts",
        //   params: [
        //     {
        //       value: null,
        //       placeholder: "Main Contact ID"
        //     },
        //     {
        //       value: null,
        //       placeholder: "Second Contact ID"
        //     },
        //     {
        //         value: null,
        //         placeholder: 'merge (false) or delete (true)'
        //     }
        //   ],
        //   action: this.mergeContacts
        // },
        {
          name: "Transfer locations between agencies",
          info: "Location Transfer endpoint has moved to Marketplace and Company Tab.",
          // url: "/location-transfers/bulk-transfer",
          // params: [
          //   {
          //     value: null,
          //     placeholder: "Old agency relationship No",
          //   },
          //   {
          //     value: null,
          //     placeholder: "New agency relationship No",
          //   },
          //   {
          //     value: null,
          //     placeholder: "Location IDs separated by commas. ID1,ID2,ID3",
          //   },
          // ],
          action: this.transferLocations,
        },
        {
          name: "Reset User Badge Counter",
          info: "Reset user's badge number",
          url: "/resetBadgeNumber",
          params: [
            {
              value: null,
              placeholder: "User id",
            },
          ],
          action: this.resetBadgeNumber,
        },
        {
          name: "Get Locations connected to FB Integration",
          info: "Get Locations connected to FB Integration",
          url: "/get_connected_locations",
          params: [
            {
              value: null,
              placeholder: "Location ID",
            },
          ],
          action: this.fbGetConnectedLocations,
        },
        {
          name: "Get Locations connected to GMB integration",
          info: "Get Locations connected to GMB integration",
          url: "/get_connected_locations",
          params: [
            {
              value: null,
              placeholder: "Location ID",
            },
          ],
          action: this.gmbGetConnectedLocations,
        },
        {
          name: "Delete GMB integration By Location ID",
          info: "Delete to GMB integration",
          url: "/gmb/support/delete_integration",
          params: [
            {
              value: null,
              placeholder: "Location ID",
            },
          ],
          action: this.deleteGmbIntegration,
        },
        {
          name: "Delete GMB integration By Places ID",
          info: "Delete to GMB integration",
          url: "/gmb/support/delete/placeId",
          params: [
            {
              value: null,
              placeholder: "Places ID",
            },
          ],
          action: this.deleteGmbIntegrationByPlacesId,
        },
        {
          name: "Create Standard Contact Fields | Create Custom Fields Folder",
          info: "Migrate Existing Custom Fields into a folder and create Contact Fields and folders",
          url: "/migrate-custom-fields",
          params: [
            {
              value: null,
              placeholder: "Location ID",
            },
          ],
          action: this.migrateCustomFields,
        },
        {
          name: "Remove Zoom Integration",
          info: "Remove Stale Zoom account of user to allow for re-integration to a new user",
          url: "/remove-zoom-integration",
          params: [
            {
              value: null,
              placeholder: "Zoom Account Email",
            },
          ],
          action: this.removeStaleOauth,
        },
        {
          name: "Remove Outlook Integration",
          info: "Remove Stale Outlook account of user to allow for re-integration to a new user",
          url: "/remove-outlook-integration",
          params: [
            {
              value: null,
              placeholder: "Outlook Account Email",
            },
          ],
          action: this.removeStaleOauth,
        },
        {
          name: "Clear Call Queue",
          info: "Please provide the phone number for which call queue needs to be cleared",
          url: "/call_queue/clear/",
          params: [
            {
              value: null,
              placeholder: "+16148556913",
            },
          ],
          action: this.clearCallQueue,
        },
        {
          name: "Mark a white label app standard",
          info: "Use this api if the app is breaching whitelabel guidelines this would mark it as standard",
          url: "/oauth/client/:id/whitelabelstatus",
          params: [
            {
              value: null,
              placeholder: "64cb5319250a5446e525e86c",
            },
          ],
          action: this.whitelabelstatus,
        },
        // {
        //   name: "Bypass Eliza Chatbot and directly go to Eliza-Agents",
        //   info: "Enter the location id for which you want to by-pass Eliza Chatbot and directly go to Eliza Agents. <br/>If the agency is not enabled for Aliza service, this will enable the agency for using Eliza Service AND will enable bypassing of Eliza Chatbot for all locations under that agency. <br/>Additionally, all the locations under this agency will be enabled for Eliza service as a whole, so, they don't have to use settings screen to enable it.",
        //   url: "dialogflow/bypass/bot",
        //   params: [
        //     {
        //       value: null,
        //       placeholder: "Location ID"
        //     }
        //   ],
        //   action: this.bypassDialogflowBot
        // },
        // {
        //   name: "Enable Eliza Bot + Agent Service",
        //   info: "Enter the location id to enable the Eliza Service for that location and all the locations under that agency",
        //   url: "dialogflow/enable/eliza_service",
        //   params: [
        //     {
        //       value: null,
        //       placeholder: "Location ID"
        //     }
        //   ],
        //   action: this.enableAgencyEliza
        // }
      ];
    },
  },
  methods: {
    async modalSubmit({ endpoint, data }) {
      if (endpoint.name === "Find User") {
        // Find user action.
        await this.findUserById(data.userId, endpoint.name);
        this.$set(this.loading, endpoint.name, false);
        return;
      }
      this.singleParamGetAction(endpoint.name, endpoint.bigResponse, endpoint, data.companyId);
    },
    closeModal(endpointName) {
      this.showModal = false;
      this.$set(this.loading, endpointName, false);
    },
    async checkForMultipleUsers(endpointName) {
      this.$set(this.loading, endpointName, true);
      const endpoint = this.supportEndpoints.find((endpoint) => endpoint.name === endpointName);

      // Get Agency Admins via rel_no#
      let rePattern = /^[0-9]{1}[-][0-9]{3}[-][0-9]{3}$/;
      let isValidRelationshipNumber = rePattern.test(endpoint.params[0].value);
      if (isValidRelationshipNumber) {
        let res = await SpmAppengineService.getAgencyAdmins(endpoint.params[0].value);
        this.bigResponse = res.data;
        this.loading[endpointName] = false;
      } else if (endpoint.multipleUsersIsPossible) {
        const queryForDeletedData = endpoint.deletedData ? "?deleted_data=true" : "";
        let response;
        try {
          response = await SpmAppengineService.checkMultipleUsers(
            endpoint.params[0].value,
            queryForDeletedData
          );
        } catch (error) {
          this.$handleError(error);
        }
        if (Array.isArray(response.data) && response.data.length > 0) {
          this.multipleUsersData = { endpoint, data: response.data };
          this.showModal = true;
        } else {
          // Single User Case.
          let companyId;
          if (response.data && response.data._data && response.data._data.company_id)
            companyId = response.data._data.company_id;
          if (endpoint.name === "Find User") {
            // Triggers from Find UserEndpoint
            this.findUserById(response.data._id, endpointName);
          } else if (endpoint.name == "Delete User") {
            this.deleteUserById(response.data._id, endpointName);
          } else {
            this.singleParamGetAction(endpointName, endpoint.bigResponse, endpoint, companyId);
          }
        }
      } else {
        this.singleParamGetAction(endpointName, endpoint.bigResponse, endpoint);
      }
    },
    async resetLocationEmail(endpointName){
      const endpoint = this.startAction(endpointName);
      const locationId = endpoint.params[0].value
      const email = endpoint.params[1].value || ''
      try {
        await LocationsService.updateLocationEmail(locationId, email);
        alert("DONE! should reflect in next few mins!");
      } catch (e) {
        const message = e?.response?.data?.message || 'Something went wrong, please connect with SaaS team';
        alert(message);
      } finally {
        this.loading[endpointName] = false;
      }
    },
    singleParamGetAction(endpointName, bigResponse = false, endpoint, companyId) {
      if (!endpoint) endpoint = this.startAction(endpointName);
      let companyQueryParam = "";
      if (companyId) {
        companyQueryParam = !endpoint.url.includes("?")
          ? `?company_id=${companyId}`
          : `&company_id=${companyId}`;
      }
      const url = endpoint.url + endpoint.params[0].value + companyQueryParam;
      this.fireRequest(url, endpointName, bigResponse);
    },
    bigResponseSingleParam(endpointName) {
      this.singleParamGetAction(endpointName, true);
    },
    addYextID(endpointName) {
      const endpoint = this.startAction(endpointName);
      const url =
        endpoint.url +
        "?location_id=" +
        endpoint.params[0].value +
        "&yext_id=" +
        endpoint.params[1].value;
      this.fireRequest(url, endpointName);
    },
    addStripeID(endpointName) {
      const endpoint = this.startAction(endpointName);
      const url =
        endpoint.url +
        "?email=" +
        endpoint.params[0].value +
        "&stripe_id=" +
        endpoint.params[1].value;
      this.fireRequest(url, endpointName);
    },
    mergeContacts(endpointName) {
      const endpoint = this.startAction(endpointName);
      const url =
        endpoint.url +
        "?main_contact=" +
        endpoint.params[0].value +
        "&second_contact=" +
        endpoint.params[1].value +
        "&delete_opportunities_and_conversations=" +
        (endpoint.params[2].value || true);
      this.fireRequest(url, endpointName);
    },
    removeSnapshot(endpointName) {
      const endpoint = this.startAction(endpointName);
      const url = endpoint.url + endpoint.params[0].value + "/" + endpoint.params[1].value;
      this.fireRequest(url, endpointName);
    },
    startAction(endpointName) {
      this.$set(this.loading, endpointName, true);
      return this.supportEndpoints.find((endpoint) => endpoint.name === endpointName);
    },
    fireRequest(url, endpointName, bigResponse = false) {
      SpmAppengineService.supportGetRequest(url)
        .then((response) => {
          if (bigResponse) this.bigResponse = response.data;
          else alert(response.data.message || JSON.stringify(response.data));
        })
        .catch((error) => {
          this.$handleError(error, (error) => {
            if (error.response && error.response.data && error.response.data.message) {
              error = error.response.data.message;
            }
            if (bigResponse) this.bigResponse = error;
            else alert(JSON.stringify(error));
          });
        })
        .finally(() => {
          this.loading[endpointName] = false;
        });
    },
    enableCalendarBeta(endpointName) {
      const endpoint = this.startAction(endpointName);
      const url = endpoint.url + endpoint.params[0].value;
      this.fireRequest(url, endpointName);
    },
    async transferLocations(endpointName) {
      router.push({ name: "support-company" });
    },
    resetBadgeNumber(endpointName) {
      const endpoint = this.startAction(endpointName);
      const url = endpoint.url + "?user_id=" + endpoint.params[0].value;
      this.fireRequest(url, endpointName);
    },
    fbGetConnectedLocations(endpointName) {
      const endpoint = this.startAction(endpointName);
      const url = `facebook/support${endpoint.url}/${endpoint.params[0].value}`;
      this.fireRequest(url, endpointName);
    },
    async gmbGetConnectedLocations(endpointName) {
      const endpoint = this.startAction(endpointName);
      try {
        const { data } = await IntegrationsService.getGmbConnectedLocations(
          endpoint.params[0].value
        );
        alert(data);
      } catch (e) {
        const message = e?.response?.data?.message;
        alert(message || "Error while fetching locations Ids");
      } finally {
        this.loading[endpointName] = false;
      }
    },
    async deleteGmbIntegration(endpointName) {
      const endpoint = this.startAction(endpointName);
      try {
        const { data } = await IntegrationsService.deleteGmbIntegration(endpoint.params[0].value);
        alert(data);
      } catch (e) {
        const message = e?.response?.data?.message;
        alert(message || "Error while deleting GMB integration");
      } finally {
        this.loading[endpointName] = false;
      }
    },
    async deleteUserById(userId, endpointName) {
      try {
        const { data } = await UserService.deleteUserById(userId);
        alert(data.message);
      } catch (e) {
        const message = e?.response?.data?.message;
        alert(message || "Error while deleting User");
      } finally {
        this.loading[endpointName] = false;
      }
    },
    async deleteGmbIntegrationByPlacesId(endpointName) {
      const endpoint = this.startAction(endpointName);
      try {
        const { data } = await IntegrationsService.deleteGmbIntegrationByPlacesId(
          endpoint.params[0].value
        );
        alert(JSON.stringify(data));
      } catch (e) {
        const message = e?.response?.data?.message || e.message;
        alert(message || "Error while deleting GMB integration by Places ID");
      } finally {
        this.loading[endpointName] = false;
      }
    },
    async migrateCustomFields(endpointName) {
      const endpoint = this.startAction(endpointName);
      const locationId = endpoint.params[0].value;

      try {
        await LocationsService.migrateCustomFields(locationId);
        alert("DONE! should apply in next 5m");
      } catch (e) {
        const message = e?.response?.data?.message;
        alert(message);
      } finally {
        this.loading[endpointName] = false;
      }
    },
    async removeStaleOauth(endpointName) {
      const endpoint = this.startAction(endpointName);
      const oauthEmail = endpoint.params[0].value;

      try {
        await CalendarService.removeStaleOauth({
          type: endpoint.url === "/remove-zoom-integration" ? "zoom" : "outlook",
          oauthEmail,
        });

        alert(
          "DONE! We've removed the given oauth. Please fire this again if the user is still not able to connect the given account to new user"
        );
      } catch (e) {
        const message = e?.response?.data?.message;
        alert(message);
      } finally {
        this.loading[endpointName] = false;
      }
    },
    bypassDialogflowBot(endpointName) {
      const endpoint = this.startAction(endpointName);
      const url = endpoint.url + "?location_id=" + endpoint.params[0].value;
      this.fireRequest(url, endpointName);
    },
    enableAgencyEliza(endpointName) {
      if (confirm("Are you sure you want to enable the Eliza Service for this location?")) {
        const endpoint = this.startAction(endpointName);
        const url = endpoint.url + "?location_id=" + endpoint.params[0].value;
        this.fireRequest(url, endpointName);
      }
    },
    resetEmailAndPassword(endpointName) {
      const endpoint = this.startAction(endpointName);
      const url =
        endpoint.url +
        "?email=" +
        endpoint.params[0].value +
        "&new_email=" +
        endpoint.params[1].value +
        "&password=" +
        endpoint.params[2].value;
      this.fireRequest(url, endpointName);
    },
    clearCallQueue(endpointName) {
      const endpoint = this.startAction(endpointName);
      const url = `${endpoint.url}${endpoint.params[0].value}`;
      this.fireRequest(url, endpointName);
    },
    async getUserDetail(endpointName) {
      // 1. UserId
      // 2. User Email
      // 3. User Phone
      try {
        this.$set(this.loading, endpointName, true);
        const endpoint = this.supportEndpoints.find((endpoint) => endpoint.name === endpointName);
        const searchTerm = endpoint.params[0].value;
        if (this.isValidEmail(searchTerm)) {
          // Email case
          this.checkForMultipleUsers(endpointName);
        } else if (this.isPhoneNumber(searchTerm)) {
          console.log("Phone number inputed");
        } else {
          // UserId case.
          await this.findUserById(searchTerm, endpointName);
          this.$set(this.loading, endpointName, false);
        }
      } catch (e) {
        console.log(e, "Find user error check");
      }
    },
    async whitelabelstatus(endpointName) {
      const endpoint = this.startAction(endpointName);
      try {
        const { data } = await OAuthService.Client.Review.updateWhiteLabelStatus(
          endpoint.params[0].value,
          {
            isWhiteLabelFriendly: false,
          }
        );
        alert(JSON.stringify(data));
      } catch (e) {
        const message = e.response.data.message || e.message;
        alert(message || "Error while marking app non white label friendly");
      } finally {
        this.loading[endpointName] = false;
      }
    },
    async findUserById(userId, endpointName) {
      try {
        // UserId case.
        const { data: user } = await UserService.getById(userId);
        let { data } = await SpmAppengineService.companyVerification("id", user.companyId);
        this.userData.user = user;
        this.userData.company = data.company;
        this.userData.showModal = true;
        this.loading[endpointName] = false;
      } catch (e) {
        console.log(e);
        console.log("Failed to fetch user");
      }
    },
    closeUserDataModal(endpointName) {
      this.userData.showModal = false;
      this.$set(this.loading, endpointName, false);
    },
  },
};
</script>

<style></style>
